import { useField } from "@imminently/decisively-ui/Form";
import { Typography } from "@mui/material";
import { JsonEditor } from "@/common/JsonEditor";

interface JSONDataEditorProps {
  value?: unknown;
  title?: string;
  readOnly?: boolean;
  height?: number;
}

const toJsonString = (value: unknown) => {
  if (typeof value === "string") return value;
  return JSON.stringify(value ?? {}, null, 2);
};

export const JSONDataEditor = ({ value, title = "Data", readOnly = false, height = 400 }: JSONDataEditorProps) => {
  const field = useField<any>({ name: "data" });

  if (value !== undefined) {
    return (
      <div className="h-full flex flex-col">
        <Typography variant="subtitle1">{title}</Typography>
        <div className="flex-grow overflow-auto" style={{ height }}>
          <JsonEditor
            value={toJsonString(value)}
            disabled={readOnly}
            readOnly={readOnly}
            withCopy
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <Typography variant="subtitle1">{title}</Typography>
      <div className="flex-grow overflow-auto -ml-8 h-[400px]">
        <JsonEditor
          name="data"
          value={typeof field.value === "string" ? field.value : JSON.stringify(field.value ?? {}, null, 2)}
          onChange={(newValue) => {
            try {
              const parsed = JSON.parse(newValue);
              field.setValue(parsed);
            } catch (e) {
              // Handle JSON parse error if needed
            }
          }}
          withCopy
        />
      </div>
    </div>
  );
};
